import { type PipelineBoard, PipelineRouteKey } from '@/pages/pipelines/common/types';

import type { InvestmentPipelineBoardFilters } from '../types';
import { normalizeInvestmentBoardPresentation } from './board-presentation';
import { filterInvestmentBoardCards } from './filter-board-cards';
import { anchorNewInvestorParentCards } from './new-investor-parent-cards';
import { addMissingInvestmentTimers } from './timers';

export const normalizeInvestmentPipelineBoard = (
  board: PipelineBoard,
  filters: Pick<InvestmentPipelineBoardFilters, 'introductionTypes' | 'timerStatuses'> = {},
  now: Date | string = new Date(),
): PipelineBoard => {
  if (board.pipeline !== PipelineRouteKey.Investment) return board;

  const anchoredBoard = anchorNewInvestorParentCards(board);
  const timedBoard = addMissingInvestmentTimers(anchoredBoard, now);
  const filteredBoard = filterInvestmentBoardCards(timedBoard, filters);

  return normalizeInvestmentBoardPresentation(filteredBoard);
};
